import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Form as BootForm } from 'react-bootstrap';
import { InputFeedback, FileUploader, Text, Separator, Input, Dropdown } from '@dmi-mch/components';
import { logger as Logger, buildSelectOptions } from '@dmi-mch/utils';
import useSWR from 'swr';
import { Icon, Row, Col, Button, Radio } from '@mch-group/uikit-components';
import styled from 'styled-components';
/**
 * This component allows to add Attachments to an entity (Artwork, Event, etc.)
 * It can grow in flexibility in the future
 *
 */

var Attachments = function Attachments(props) {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      attachmentTypes = _React$useState2[0],
      setAttachmentTypes = _React$useState2[1];

  var _React$useState3 = React.useState(props.visibleItemsOnStart),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      visibleItems = _React$useState4[0],
      setVisibleItems = _React$useState4[1];

  var fetchUrl = "/msvc/v1/translations/values/Label/Attachments/allFields/".concat(props.language);

  var fetcher = function fetcher(url) {
    return props.context.http.get(url).then(function (res) {
      return res.data;
    });
  };

  var _useSWR = useSWR(fetchUrl, fetcher, {
    revalidateOnFocus: false
  }),
      labels = _useSWR.data;

  var _useSWR2 = useSWR('/msvc/v1/attachments/metadata', fetcher, {
    revalidateOnFocus: false
  }),
      attachmentTypesList = _useSWR2.data;

  var maxNumberOfMaxAttachments = React.useRef(null);
  var isMaskingActive = props.attachments && props.attachments.length > props.visibleItemsOnStart;

  var toggleVisibleItems = function toggleVisibleItems() {
    if (visibleItems <= props.attachments.length) {
      setVisibleItems(props.attachments.length + 1);
    } else {
      setVisibleItems(props.visibleItemsOnStart);
    }
  };

  React.useEffect(function () {
    var fetchAttachmentTypes = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var attListWithoutLabels, attListWithLabels;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  if (attachmentTypesList) {
                    maxNumberOfMaxAttachments.current = attachmentTypesList.length; // How each field of the JSON will convert into a dropdown field

                    attListWithoutLabels = attachmentTypesList.find(function (item) {
                      return item.id === props.entityType.toString();
                    }).types; // Connecting with the labels coming from the CMS

                    attListWithLabels = attListWithoutLabels.map(function (item) {
                      var newItem = _objectSpread({}, item);

                      newItem.labelText = labels.Label.Attachments[item.shortcode];
                      return newItem;
                    });
                    setAttachmentTypes(attListWithLabels);
                  }
                } catch (e) {
                  Logger(e);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchAttachmentTypes() {
        return _ref.apply(this, arguments);
      };
    }(); // tIf there is an ID in parent props and event does not exist yet, fetch the event. Otherwise, it's add mode


    if (!attachmentTypes && labels) {
      fetchAttachmentTypes();
    }
  }, [attachmentTypes, attachmentTypesList, labels, props.entityType]);
  var connectListAndDropdown = {
    key: 'shortcode',
    value: 'shortcode',
    text: 'labelText',
    name: 'labelText',
    extrafield1: 'svgIcon'
  };
  var attTypesDropdownFormat = React.useMemo(function () {
    return attachmentTypes && buildSelectOptions(attachmentTypes, connectListAndDropdown).map(function (item) {
      /* Deciding which items in the list will be disabled. Tthis was so simple
      when the list was hardcoded, and it got so messed when the list was decided to be dynamic. */
      var newItem = _objectSpread({}, item);

      newItem.disabled = !!props.attachments.find(function (attItem) {
        return attItem.type === item.value;
      });
      return newItem;
    });
  }, [attachmentTypes, connectListAndDropdown, props.attachments]);
  var initialValues = {
    url: '',
    docType: null,
    attachType: 'url'
  };

  if (props.isReadOnly) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className
    }, props.attachments.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
      className: "table table-sm w-auto"
    }, /*#__PURE__*/React.createElement("tbody", null, props.attachments.map(function (item, i) {
      if (i >= visibleItems) return null;
      return /*#__PURE__*/React.createElement("tr", {
        key: item.id || item.key
      }, /*#__PURE__*/React.createElement("td", {
        className: "text-nowrap"
      }, /*#__PURE__*/React.createElement(Text, {
        isHtml: true,
        as: "span"
      }, attTypesDropdownFormat && attTypesDropdownFormat.find(function (att) {
        return att.value === item.type;
      }).extrafield1)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        href: item.url,
        target: "_blank"
      }, attTypesDropdownFormat && attTypesDropdownFormat.find(function (att) {
        return att.value === item.type;
      }).name)));
    }))), isMaskingActive && visibleItems <= props.attachments.length && /*#__PURE__*/React.createElement(Button, {
      className: "view-more",
      onClick: toggleVisibleItems
    }, /*#__PURE__*/React.createElement("b", null, labels && labels.Label.Attachments.viewMoreButtonLabel))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: props.className
  }, props.attachments.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
    className: "table table-sm"
  }, /*#__PURE__*/React.createElement("tbody", null, props.attachments.map(function (item, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: item.id || item.key
    }, /*#__PURE__*/React.createElement("td", {
      className: "text-nowrap"
    }, /*#__PURE__*/React.createElement(Text, {
      isHtml: true,
      as: "span"
    }, attTypesDropdownFormat && attTypesDropdownFormat.find(function (att) {
      return att.value === item.type;
    }).extrafield1)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: item.url,
      target: "_blank"
    }, attTypesDropdownFormat && attTypesDropdownFormat.find(function (att) {
      return att.value === item.type;
    }).name)), /*#__PURE__*/React.createElement("td", {
      align: "right",
      style: {
        whiteSpace: 'nowrap'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "compact",
      variant: "secondary",
      onClick: function onClick() {
        var newAttachments = _toConsumableArray(props.attachments);

        newAttachments.splice(i, 1);
        props.setFieldValue('attachments', newAttachments);
        props.setFieldTouched('attachments', true);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "delete"
    }))));
  }))), /*#__PURE__*/React.createElement(Separator, null)), /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    onSubmit: function onSubmit(values, _ref2) {
      var resetForm = _ref2.resetForm;
      props.setFieldValue('attachments', [].concat(_toConsumableArray(props.attachments), [{
        entityId: props.entityId,
        entityType: props.entityType,
        type: values.docType,
        url: values.url,
        key: Math.random(values.url),
        // New items have no ID, so let's just put something
        isNew: true
      }]));
      resetForm(initialValues);
      props.setFieldTouched('attachments', true);
    },
    validationSchema: function validationSchema() {
      var schema = {
        url: Yup.string() // .url('Please enter a valid url') // Gives problems with certain URLs
        .required(),
        docType: Yup.string().required()
      };
      return Yup.object().shape(schema);
    }
  }, function (subformik) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      columns: 12
    }, /*#__PURE__*/React.createElement(Col, {
      md: props.twelveCols ? 4 : 6
    }, /*#__PURE__*/React.createElement("fieldset", {
      className: "border-bottom",
      disabled: props.attachments.length >= maxNumberOfMaxAttachments.current
    }, /*#__PURE__*/React.createElement(Dropdown, {
      placeholder: props.typesDropdownPlaceholder,
      label: labels && labels.Label.Attachments.typesDropdownLabel,
      selectOnBlur: false,
      name: "docType",
      fluid: true,
      options: attTypesDropdownFormat || [],
      value: subformik.values.docType,
      onChange: function onChange(e) {
        subformik.setFieldValue('docType', e.target.value);
      }
    }, attTypesDropdownFormat && attTypesDropdownFormat.map(function (element) {
      return /*#__PURE__*/React.createElement("option", {
        value: element.value
      }, element.text);
    })), subformik.errors.docType && subformik.touched.docType && /*#__PURE__*/React.createElement(InputFeedback, null, subformik.errors.docType))), /*#__PURE__*/React.createElement(Col, {
      md: props.twelveCols ? 3 : 4
    }, /*#__PURE__*/React.createElement("div", {
      className: "radiobuttons"
    }, /*#__PURE__*/React.createElement(Row, {
      className: "radiobuttons__title"
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("fieldset", {
      disabled: !subformik.values.docType
    }, /*#__PURE__*/React.createElement("label", null, "\xA0")))), /*#__PURE__*/React.createElement(Row, {
      className: "radiobuttons__group"
    }, /*#__PURE__*/React.createElement(BootForm.Group, {
      inline: true,
      className: "d-flex gap-5"
    }, /*#__PURE__*/React.createElement("fieldset", {
      disabled: !subformik.values.docType
    }, /*#__PURE__*/React.createElement(Radio, {
      style: {
        width: 'auto'
      },
      name: "attachType",
      label: "URL",
      onChange: function onChange() {
        subformik.setFieldValue('url', '');
        subformik.setFieldValue('attachType', 'url');
      },
      value: subformik.values.attachType,
      checked: subformik.values.attachType === 'url'
    })), /*#__PURE__*/React.createElement("fieldset", {
      disabled: !subformik.values.docType
    }, /*#__PURE__*/React.createElement(Radio, {
      name: "attachType",
      label: "PDF",
      onChange: function onChange() {
        subformik.setFieldValue('url', '');
        subformik.setFieldValue('attachType', 'pdf');
      },
      value: subformik.values.attachType,
      checked: subformik.values.attachType === 'pdf'
    })))))), /*#__PURE__*/React.createElement(Col, {
      md: props.twelveCols ? 5 : 6
    }, subformik.values.attachType === 'url' && /*#__PURE__*/React.createElement("fieldset", {
      className: "border-bottom",
      disabled: !subformik.values.docType
    }, /*#__PURE__*/React.createElement("label", {
      style: {
        color: !subformik.values.docType ? '#ccc' : 'black'
      }
    }, /*#__PURE__*/React.createElement("b", null, labels && labels.Label.Attachments.urlInputLabel)), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      name: "url",
      value: subformik.values.url || '',
      onChange: subformik.handleChange
    }), subformik.errors.url && subformik.touched.url && /*#__PURE__*/React.createElement(InputFeedback, null, subformik.errors.url)), subformik.values.attachType === 'pdf' && /*#__PURE__*/React.createElement("fieldset", {
      disabled: !subformik.values.docType
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("b", null, labels && labels.Label.Attachments.uploadFileLabel)), /*#__PURE__*/React.createElement(FileUploader, {
      nameForNewFile: subformik.values.docType && attachmentTypes && attachmentTypes.find(function (item) {
        return item.shortcode === subformik.values.docType;
      }).name,
      pathToNewFile: "artwork-attachments/".concat(props.entityId),
      setFieldValue: subformik.setFieldValue,
      configuration: props.configuration,
      configurationS3: props.configurationS3,
      disabled: !subformik.values.docType,
      acceptedFileFormats: "application/pdf"
    }), subformik.errors.url && subformik.touched.url && /*#__PURE__*/React.createElement(InputFeedback, null, subformik.errors.url)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: props.twelveCols ? 6 : 8
    }), /*#__PURE__*/React.createElement(Col, {
      md: props.twelveCols ? 6 : 8,
      align: "right"
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: !subformik.values.url.length > 0,
      type: "button",
      variant: "secondary",
      size: "compact",
      onClick: function onClick() {
        return subformik.submitForm();
      }
    }, labels && labels.Label.Attachments.addButtonLabel))));
  }));
};

Attachments.propTypes = {
  option1: PropTypes.string,
  option2: PropTypes.string,
  attachments: PropTypes.array,
  entityType: PropTypes.number,
  entityId: PropTypes.number,
  className: PropTypes.string,
  context: PropTypes.object,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  configuration: PropTypes.object,
  configurationS3: PropTypes.object,
  twelveCols: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  visibleItemsOnStart: PropTypes.number,
  saveWarningText: PropTypes.string,
  addButtonText: PropTypes.string,
  uploadFileText: PropTypes.string,
  urlInputText: PropTypes.string,
  typesDropdownLabel: PropTypes.string,
  typesDropdownPlaceholder: PropTypes.string,
  viewMoreButtonLabel: PropTypes.string,
  language: PropTypes.string
};
var AttachmentsStyled = styled(Attachments).withConfig({
  displayName: "Attachments__AttachmentsStyled",
  componentId: "sc-6eltiv-0"
})(["table{tr{td{border-top:0px solid var(--bs-mch-white);border-bottom-width:0px;a{text-decoration:underline;color:#444749;}", "}}", "}.view-more{font-size:14px;}div .input{input,svg{cursor:pointer;}}"], function (props) {
  return props.isReadOnly && "\n          font-size: 15px;\n          border-top: 0px !important;\n          padding: 5px;\n          ";
}, function (props) {
  return props.isReadOnly && "\n      margin-bottom: 7px;\n      ";
});
export default AttachmentsStyled;